// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"61":"0dfd1a11","491":"08a88099"}[chunkId] + ".js";
};